import { render } from "./respiratory-rate.vue?vue&type=template&id=4310e94a&scoped=true"
import script from "./respiratory-rate.vue?vue&type=script&lang=js"
export * from "./respiratory-rate.vue?vue&type=script&lang=js"

import "./respiratory-rate.vue?vue&type=style&index=0&id=4310e94a&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4310e94a"]])

export default __exports__